import { db, firebaseApp, storage } from "../firebase";
import { getUid } from "./auth";
import { Collections } from "./collections";
import { addSubmission } from "./submission";
import "firebase/compat/functions";
import { CompanyGameInterface } from "../db/models/company/game";

export const getStudentGames = (rmIds: string[]): Promise<CompanyGameInterface[]> => {
    if (!rmIds || rmIds.length === 0) return Promise.resolve([]);
    return db
        .collection(Collections.GAMES)
        .where("rmId", "in", rmIds)
        .get()
        .then((snapshot) => {
            let res: CompanyGameInterface[] = [];
            snapshot.forEach((doc) => {
                res.push(doc.data() as CompanyGameInterface);
            });
            return Promise.resolve(res);
        })
        .catch(function (error) {
            return Promise.reject(error);
        });
};

export const getGamesByRmId = (rmId) => {
    if (!rmId) return Promise.reject("Bad params");

    return db
        .collection(Collections.GAMES)
        .where("rmId", "==", rmId)
        .get()
        .then(snapshot => {
            let res: CompanyGameInterface[] = [];
            snapshot.forEach((doc) => res.push(doc.data() as CompanyGameInterface));
            return res;
        });
};

export const getFollowActiveGames = (rmId: string, groupIds: string[]) => {
    if (!rmId) return Promise.resolve([]);

    return db
        .collection(Collections.GAMES)
        .where("rmId", "==", rmId)
        .where("state", "==", "ACTIVE")
        .where("deadline", ">=", new Date())
        .where("target", "in", groupIds)
        .get()
        .then(snapshot => {
            let res: CompanyGameInterface[] = [];
            snapshot.forEach((doc) => res.push(doc.data() as CompanyGameInterface));
            return res;
        });
}

export const getRmGamesByTarget = async (rmId: string, groupIds: string[]): Promise<CompanyGameInterface[]> => {
    if (!rmId || !groupIds) return Promise.reject("Bad params");

    try {
        const snapshot = await db
            .collection(Collections.GAMES)
            .where("rmId", "==", rmId)
            .where("state", "==", "ACTIVE")
            .where("target", "in", groupIds)
            .get();
        let res: CompanyGameInterface[] = [];
        snapshot.forEach((doc) => res.push(doc.data() as CompanyGameInterface));
        return res;
    } catch (error) {
        return Promise.resolve([]);
    }
}

export const deleteGame = async gameId => {
    if (!gameId) return Promise.reject("manca gameId");

    const gameRef = db
        .collection(Collections.GAMES)
        .doc(gameId);

    // get all submissions
    let snapshot = await gameRef
        .collection(Collections.SUBMISSIONS)
        .get();

    // delete submissions
    let batch = db.batch();
    snapshot.docs.forEach((doc) => {
        if (doc.exists) batch.delete(doc.ref);
    });

    // delete game
    batch.delete(gameRef);

    return batch.commit();
}

export const getFollowClosedAttendedGames = async (rmId, gameIds) => {
    if (!rmId || !gameIds) return Promise.reject("Bad params");

    const attendedGamePromises = gameIds.map(gameId => db.collection(Collections.GAMES).doc(gameId).get());
    const attendedGameDocs = await Promise.all(attendedGamePromises);
    const attendedGames = attendedGameDocs.map(doc => doc.data())
        .filter(g => g); // remove null documents
    return Promise.resolve(attendedGames);
}

export const uploadSubmission = (partialSubDocData, file, storagePath, subDocPath, onComplete, onError) => {
    if (!file) return;

    const uid = getUid();
    if (!uid) return Promise.reject("no uid");

    const uploadTask = storage.ref(storagePath).put(file);
    return uploadTask.on(
        "state_changed",
        (snapshot) => {
            // const progress = Math.round(
            // 	(snapshot.bytesTransferred / snapshot.totalBytes) * 100
            // );
        },
        (error) => {
            console.error(error);
            if (onError) onError();
        },
        () => {
            storage
                .ref(storagePath)
                .getDownloadURL()
                .then(async (url) => {
                    // await db.doc(docId).update(fieldPath, url);

                    const subDocData = {
                        ...partialSubDocData,
                        files: {
                            [file.name]: url
                        }
                    }

                    await addSubmission(subDocData);

                    if (onComplete) onComplete();
                })
                .catch((error) => console.error(error));
        }
    );
};